import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const FigureDesc72 = {
    title: "Figure 72: Examples of Phasing Plans and Schedules which may be used by Courts. ",
    para1: <>
        <p>
            The figure shows a phasing plan for the construction of a building over a period of time. The key to the figure is given at the head of the plan. “X” represents the construction that was planned out in the first phase, “X+2” in the second phase, “X+4” in the third phase, up to the 5th phase.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The first phase is depicted in pink and  includes construction of areas upto “X” years and includes the central portions of the courtroom.",
                    "The second phase of the construction is depicted in blue and includes the top left corner of the complex, middle left, and some spaces at the foot of the plan. There are two phases of construction in the second phase. The second phase is estimated to take “X+2” years.",
                    "The third phase is depicted in beige  and includes construction of the bottom left corner of the court building, the top right box and the bottom left box of the court complex figure. This third phase is estimated to take “X+4” years.",
                    "The fourth phase includes the construction of the complex depicted by red dotted lines and covers the outline of the central portion of the court building.  This phase is estimated to take “X+6” years.",
                    "The fifth phase is depicted in grey and covers the area on top of the court complex figure. This phase is estimated to take “X+8” years.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc73 = {
    title: "Figure 73: Stages involved in the retrofitting process. ",
    para1: <>
        <p>
            <span><b>Orientation: </b></span>
            The figure depicts the detailed stages of the retrofitting process. The figure is described from left to right.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The retrofitting process has been described in two rows of three boxes on each row.",
                    "The first box in the top left corner is titled “Stakeholder/User Engagement”. This box bifurcates and one end leads to the box titled “Audit Process” while the other end leads to the second row of boxes.",
                    <>
                        The sub-points in the box titled “Stakeholder/User Engagement” are:
                        {getCircleTypeListItem([
                            "User experience survey and needs assessment",
                            "Goals and objectives outcomes"

                        ])}
                    </>,

                    <>
                        The next box is titled “Audit Process” and the subpoints in this box are:
                        {getCircleTypeListItem([
                            "Audit framework",
                            "User-based evaluation systems (management), equipment/infrastructure, space design, building services, amenities, etc. "
                        ])}
                    </>,

                    <>
                        The next box is titled “Retrofitting Design options” and the subpoints in this box are:
                        {getCircleTypeListItem([
                            "Risks & opportunities assessment",
                            "Technical feasibility",
                            "Economic viability - cost benefit analysis and resource availability"

                        ])}
                    </>,

                    <>
                        The next box connected is the box in the second row in the bottom right corner of the image. This is titled “Detailed design plans” and the subpoints in this box are:
                        {getCircleTypeListItem([
                            "Best practice studies",
                            "Handbook application",
                            "Stakeholder consultation",
                            "Plans of proposed design.",

                        ])}
                    </>,

                    <>
                        This is connected to the box titled “Implementation” and the subpoints in this box are:
                        {getCircleTypeListItem([
                            "Work plan with budget",
                            "Monitoring of design with stakeholder involvement",

                        ])}
                    </>,

                    <>
                        The last box in the image in the bottom left corner is titled “Management of designs”  and the subpoints in this box are:
                        {getCircleTypeListItem([
                            "Maintenance procedures/policies",
                            "Training & capacity building",
                            "Post retrofitting evaluation with user surveys.",

                        ])}
                    </>,

                    "All the boxes in the image are interconnected to ensure preparedness while retrofitting."
                ])}
            </div>
        </p>
    </>
}

export const FigureDesc74 = {
    title: "Figure 74: Representation of the operations of the Building Management System. ",
    para1: <>
        <p>
            <span><b>Orientation: </b></span>
            The figure depicts A Building Management System that may be implemented in a  Court Complex.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The right side of the image shows a three-storey court complex.",
                    "The left side of the image depicts five layers of management systems required for the court system.",
                    <>
                        From bottom to top, the first layer is on Building Data Network and consists of the following components:
                        {getCircleTypeListItem([
                            "Voice and Data (Telephony)",
                            "Video (Conferencing)",
                            "Web (Internet/Intranet)",
                            "Wifi/wireless (DAS & cellular)",
                        ])}
                    </>,

                    <>
                        The second layer is on Security and Safety Measures and consists of the following components:
                        {getCircleTypeListItem([
                            "Fire/Life Safety",
                            "Security",
                            "24/7 Monitoring",
                        ])}
                    </>,

                    <>
                        The third layer is on  ICT & AV Services and consists of the following components:
                        {getCircleTypeListItem([
                            "Information and Communication Technology Systems",
                            "Access/Video",
                        ])}
                    </>,

                    <>
                        The fourth layer is on  HVAC & Lighting Systems and consists of the following components:
                        {getCircleTypeListItem([
                            "Lighting",
                            "HVAC",
                        ])}
                    </>,

                    <>
                        The fifth and final layer is on Energy Management & Elevators and consists of the following components:
                        {getCircleTypeListItem([
                            "Elevators",
                            "Energy Management"
                        ])}
                    </>,
                ])}
            </div>
        </p>
    </>
}

export const FigureDesc75 = {
    title: "Figure 75: Methods and benefits of sustainable construction.",
    para1: <>
        <p>
            The figure depicts methods and benefits of sustainable construction practices.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The image in the centre of the figure has been divided into two halves. There is a continuous arrow around it which indicates that it is a cyclical process.",
                    "The first semi circle represents the Construction phase and the second semi circle represents the Post-Construction phase of a District Court.",
                    <>
                        The methods and benefits of sustainable construction have been depicted through 12 icons. From bottom left (anti-clockwise) these are:
                        {getCircleTypeListItem([
                            "Green roofs",
                            "Solar Panels", 
                            "Rainwater harvesting system", 
                            "Energy efficient devices and fixtures",
                            "Natural light and ventilation",
                            "Eco-friendly construction materials ",
                            "Durable and maintainable design",
                            "Efficient waste disposal systems", 
                            "Smart technologies", 
                            "Well-maintained building services",
                            "Site level waste management",
                            "Water resource conservation",
                            
                        ])}
                    </>
                ])}
            </div>
        </p>
    </>
}





